<template>
  <div class="base-table" :class="{ 'table-responsive': responsive, 'sticky-header': stickyHeader }" ref="tableContainerRef">
    <slot name="table-header"></slot>
    <table
      class="table"
      :class="{ 'table-hover': hover }"
      v-sortable-row="sortableRowOptions"
      v-sortable-col="sortableColOptions"
      ref="tableRef"
      :key="`key-${keyChange}`"
    >
      <thead>
        <tr v-if="busy">
          <th :colspan="displayedColumns.length + 1 || 10" class="table-busy">
            <div class="loading-header" />
          </th>
        </tr>
        <tr v-else>
          <th class="base-table-expand-container" v-if="expand && !expandEndColumn == true">
            <slot name="toggle-expand"> {{ columnLabelExpand }} </slot>
          </th>
          <th class="base-table-checkbox-container" v-if="checkbox">
            <slot name="select-all-row">
              <input v-model="isSelectAll" class="form-check-input" type="checkbox" @change="onSelectAllRow(isSelectAll, $event)" />
            </slot>
          </th>

          <th
            v-for="(col, index) in displayedColumns"
            :key="`column-${col.key}`"
            class="dragable-col"
            :class="[col.key, { 'dynamic-filter': col.sortable }]"
            :id="'' + col.column_id"
          >
            <div class="sorting-content-container" v-if="col.sortable">
              <input type="checkbox" :id="`sorting-${col.key}`" @change="onSort($event, col)" class="d-none sorting-checkbox" />
              <label :for="`sorting-${col.key}`" class="w-100">
                <div class="d-flex align-items-center">
                  <div class="handle-dragable" v-if="sortableCol">
                    <DragableIcon class="dragable-icon handle-dragable-col" />
                  </div>
                  <div class="column-content">
                    <slot :name="`head(${col.key})`" :item="col" :index="index">{{ col.label || '' }}</slot>
                  </div>
                  <div v-if="col.sortable" class="sorting-icon-container">
                    <SortingIcon class="sorting-icon" />
                    <SortingIconUp class="sorting-icon-up" />
                    <SortingIconDown class="sorting-icon-down" />
                  </div>
                </div>
              </label>
            </div>
            <div v-else>
              <div class="d-flex align-items-center">
                <div class="handle-dragable" v-if="sortableCol">
                  <DragableIcon class="dragable-icon handle-dragable-col" />
                </div>
                <div class="column-content">
                  <slot :name="`head(${col.key})`" :item="col" :index="index">{{ col.label || '' }}</slot>
                </div>
              </div>
            </div>
          </th>

          <th class="base-table-expand-container" v-if="expand && expandEndColumn == true">
            <slot name="toggle-expand"> {{ columnLabelExpand }} </slot>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="busy">
          <td :colspan="displayedColumns?.length + 1 || 10" class="table-busy">
            <div class="table-busy-content">
              <slot name="busy">
                <span class="loader"></span>
              </slot>
            </div>
          </td>
        </tr>
        <template
          v-for="(row, rowIndex) in displayedData"
          v-bind:key="`${rowIndex}:${rowKeyChang}`"
          v-else-if="displayedData && displayedData.length"
        >
          <tr
            class="dragable-row tr-row"
            :style="row.checkbox ? `background-color:${rowColorSelect ? rowColorSelect : 'rgb(247 247 247)'};` : ''"
            @click="onRowClick(row)"
          >
            <td class="base-table-expand-container" v-if="expand && !expandEndColumn == true" style="vertical-align: middle">
              <slot name="toggle-expand-row" :row="row">
                <span v-if="row.expand == true" class="tick-expand fs-4" @click.stop="onClickExpand(Number(rowIndex))">
                  <arrow-expand-icon class="flip" fill="#0077FF" :class="{ 'flip-expand': isClickExpand[Number(rowIndex)] }" />
                </span>
              </slot>
            </td>
            <td class="base-table-checkbox-container" v-if="checkbox" style="vertical-align: middle">
              <slot name="select-row" :row="row">
                <input
                  v-model="row.checkbox"
                  :id="`input-row-${rowIndex}`"
                  class="form-check-input"
                  type="checkbox"
                  @click.stop
                  @change="onSelectRow(row, rowIndex)"
                  :class="onSomeCheckboxExpand(row, rowIndex) ? 'form-check-expand-input' : ''"
                />
              </slot>
            </td>

            <td
              v-for="(col, colIndex) in displayedColumns"
              :key="`row-${rowIndex}-col-${colIndex}`"
              class="row-container"
              :class="col.key"
              style="vertical-align: middle"
              :style="col.selectCustom == true ? '' : 'max-width: 400px; min-width: 100px'"
            >
              <slot :name="`cell(${col.key})`" :item="row" :index="rowIndex">
                <div
                  v-if="textOverflow"
                  :class="textOverflow == 'one_line_ellipsis' ? 'text-1' : 'text-3'"
                  @mousemove="onLongText(row[col.key] || '', textOverflow, $event)"
                  @mouseleave="closeLongText"
                >
                  {{ displayCellValue(row[col.key]) }}
                </div>
                <div v-else>
                  {{ displayCellValue(row[col.key]) }}
                </div>
              </slot>
            </td>
            <td class="base-table-expand-container" v-if="expand && expandEndColumn == true" style="vertical-align: middle">
              <slot name="toggle-expand-row" :row="row">
                <span v-if="row.expand == true" class="end-tick-expand fs-4" @click.stop="onClickExpand(Number(rowIndex))">
                  <arrow-expand-icon class="flip" fill="#0077FF" :class="{ 'flip-expand': isClickExpand[Number(rowIndex)] }" />
                </span>
              </slot>
            </td>
          </tr>
          <tr
            class="dragable-row-expand tr-row-expand"
            :class="{
              'hide-ele': isHideExpand[Number(rowIndex)] == true,
            }"
            v-show="isClickExpand[Number(rowIndex)] == true"
          >
            <td class="px-5" :colspan="colspanValue" style="background-color: rgb(243 243 243)">
              <div style="overflow-x: auto">
                <!-- Table Expand -->
                <table class="table">
                  <thead>
                    <tr class="column-expand">
                      <th class="base-table-checkbox-container" v-if="checkboxExpand" style="vertical-align: middle"></th>
                      <th v-for="(col, colIndex) in displayedColumnsExpand" v-bind:key="colIndex" v-show="showColumnsExpand">
                        <slot :name="`headExpand(${col.key})`">{{ col.label }}</slot>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="dataExpand != undefined">
                    <tr
                      class="row-expand"
                      :style="row.checkbox ? `background-color:${rowColorSelect ? rowColorSelect : 'rgb(247 247 247)'};` : ''"
                      v-for="(rowDataExpand, rowExpandIndex) in displayedDataExpand[Number(rowIndex)]"
                      :key="`${rowExpandIndex}:${rowDataExpand.checkbox}`"
                      @click="onRowExpandClick(rowDataExpand)"
                    >
                      <td class="base-table-checkbox-container" v-if="checkboxExpand" style="vertical-align: middle">
                        <slot name="select-row-expand" :row="rowDataExpand">
                          <input
                            class="form-check-input"
                            v-model="rowDataExpand.checkbox"
                            type="checkbox"
                            @click.stop
                            @change="onSelectRowExpand(rowDataExpand, rowIndex)"
                          />
                        </slot>
                      </td>

                      <td v-for="(col, colIndex) in displayedColumnsExpand" v-bind:key="colIndex" style="max-width: 300px; min-width: 100px">
                        <slot :name="`cellExpand(${col.key})`" :item="rowDataExpand" :index="colIndex">
                          <div
                            v-if="textOverflow"
                            :class="textOverflow == 'one_line_ellipsis' ? 'text-1' : 'text-3'"
                            @mousemove="onLongText(rowDataExpand[col.key] || '', textOverflow, $event)"
                            @mouseleave="closeLongText"
                          >
                            {{ displayCellValue(rowDataExpand[col.key]) }}
                          </div>
                          <div v-else>
                            {{ displayCellValue(rowDataExpand[col.key]) }}
                          </div>
                        </slot>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="empty-table">
                      <td :colspan="colspanValue || 10">
                        <slot name="empty-expand">
                          <div class="d-inline-block text-center">
                            <EmptyTableIcon />
                            <slot name="empty-expand-label">
                              <div class="mt-2 empty-table-label">{{ t('base_table.noItems') }}</div>
                            </slot>
                          </div>
                        </slot>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </template>

        <tr class="empty-table" v-else>
          <td :colspan="displayedColumns?.length + 1 || 10">
            <slot name="empty">
              <div class="d-inline-block text-center">
                <EmptyTableIcon />
                <slot name="empty-label">
                  <div class="mt-2 empty-table-label">{{ t('base_table.noItems') }}</div>
                </slot>
              </div>
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="tooltip-text"
      ref="tooltipTextRef"
      :style="displayMode ? `top: ${tooltipStyle.top}px; left: ${tooltipStyle.left}px;` : 'display: none; '"
      style="max-width: 300px"
    >
      <div class="title"></div>
      <div class="detail">
        {{ tooltipData }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import SortingIconUp from '@/assets/icons/base/table/SortingIconUp.vue';
import SortingIconDown from '@/assets/icons/base/table/SortingIconDown.vue';
import SortingIcon from '@/assets/icons/base/table/SortingIcon.vue';
import EmptyTableIcon from '@/assets/icons/base/table/EmptyTableIcon.vue';
import DragableIcon from '@/assets/icons/base/table/DragableIcon.vue';

import ArrowExpandIcon from '@/assets/icons/base/navbarIcon/ArrowDownIcon.vue';
import { displayCellValue } from '@/utils/formatCellValue';

import { sortableRow as vSortableRow, sortableCol as vSortableCol } from './hooks/directive';
import useSelectExpandTable from './hooks/useSelectExpandTable';

const { t } = useI18n();

interface Props {
  data?: Array<SelectExpandTable.dataTable | Record<string, any>>;
  columns: Array<SelectExpandTable.TableColumn>;
  checkbox?: boolean;
  checkboxExpand?: boolean;
  selectAll?: boolean;
  busy?: boolean;
  hover?: boolean;
  responsive?: boolean;
  stickyHeader?: boolean;
  sortableRow?: boolean;
  sortableCol?: boolean;
  rowColorSelect?: string;
  currentPage?: number;
  perPages?: number;
  // Expand
  dataExpand?: Array<SelectExpandTable.dataExpand>;
  columnsExpand?: Array<SelectExpandTable.expandTableColumn>;
  /**
   * โชว์ expand ได้ row เดียว
   */
  expandOneOnly?: boolean;
  /**
   * show Columns Expand
   */
  showColumnsExpand?: boolean;
  /**
   * แสดง expand
   */
  expand?: boolean;
  /**
   * ปุ่มสำหรับ expand อยู่ column หลังสุด
   */
  expandEndColumn?: boolean;
  columnLabelExpand?: string;
  //
  /**
   * กำหนด บรรทัดแสดง text
   */
  textOverflow?: 'one_line_ellipsis' | 'three_line_ellipsis';
}

const props = defineProps<Props>();

const emit = defineEmits([
  'row-change',
  'col-change',
  'sorting-change',
  'row-click',
  'row-expand-click',
  'select-all-row',
  'row-select',
  'expand-select',
  'on-data-filter',
  'on-remove-item',
  'on-clear-data-filter',
  'on-selected-sorting',
  'on-expand',
]);

const {
  rowKeyChang,
  tableRef,
  tableContainerRef,
  sortableRowOptions,
  sortableColOptions,
  keyChange,
  displayedData,
  displayedDataExpand,
  displayedColumns,
  displayedColumnsExpand,
  colspanValue,
  isClickExpand,
  isHideExpand,
  isSelectAll,
  tooltipData,
  tooltipStyle,
  displayMode,
  tooltipTextRef,
  onSelectAllRow,
  onSelectRow,
  onSelectRowExpand,
  onSort,
  onRowClick,
  onRowExpandClick,
  onClickExpand,
  onSomeCheckboxExpand,
  onLongText,
  closeLongText,
} = useSelectExpandTable(props);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/select-expand-table';
@import '@/assets/styles/base/filter-table/filter-in-table.scss';

.tick-expand {
  width: 7px;
  height: 11px;
  color: #0077ff;

  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}
.end-tick-expand {
  width: 7px;
  height: 11px;
  color: #0077ff;
  padding: 0 1.5rem;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

.flip {
  transition: transform 0.3s;
  transform: rotate(-180deg);
}
.flip-expand {
  transform: rotate(-90deg);
}

@keyframes hideElement {
  from {
    display: revert;
  }
  to {
    opacity: 0;
  }
}

.hide-ele {
  animation: hideElement 200ms forwards;
  display: none;
}

// Loading...
.loader {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: block;
  margin: 15px auto;
  position: relative;
  color: #5c5c5c;
  box-sizing: border-box;
  animation: animloader 2s linear infinite;
}

@keyframes animloader {
  0% {
    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px;
  }
  25% {
    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 2px;
  }
  50% {
    box-shadow: 14px 0 0 -2px, 38px 0 0 -2px, -14px 0 0 2px, -38px 0 0 -2px;
  }
  75% {
    box-shadow: 14px 0 0 2px, 38px 0 0 -2px, -14px 0 0 -2px, -38px 0 0 -2px;
  }
  100% {
    box-shadow: 14px 0 0 -2px, 38px 0 0 2px, -14px 0 0 -2px, -38px 0 0 -2px;
  }
}
</style>
